<script>
	import { loginWithKey, loginWithEmail, requestPasswordReset } from "../services/api";

	export let onLoginSuccess = () => {};
	export let onOpenMaster = () => {};

	let accessKey = "";
	let email = "";
	let password = "";
	let showPassword = false;
	let isLoggingIn = false;
	let loginError = "";

	// Estado da Recuperação de Senha (Fase D)
	let showForgotModal = false;
	let forgotEmail = "";
	let isSendingForgot = false;
	let forgotMessage = "";
	let forgotError = "";

	async function handleForgotPassword() {
		const clean = forgotEmail.trim();
		if (!clean || !clean.includes("@")) {
			forgotError = "Informe um e-mail válido.";
			return;
		}
		isSendingForgot = true;
		forgotError = "";
		forgotMessage = "";
		try {
			const res = await requestPasswordReset(clean);
			forgotMessage = res.message || "Se o e-mail estiver cadastrado, enviaremos as instruções de recuperação.";
		} catch (err) {
			forgotError = err.message || "Não foi possível enviar o e-mail de recuperação. Tente novamente.";
		} finally {
			isSendingForgot = false;
		}
	}

	function closeForgotModal() {
		showForgotModal = false;
		forgotEmail = "";
		forgotMessage = "";
		forgotError = "";
	}

	async function handleKeyLogin() {
		const keyToUse = accessKey.trim();
		if (!keyToUse) {
			loginError = "Por favor, digite a sua Chave de Acesso.";
			return;
		}
		isLoggingIn = true;
		loginError = "";
		try {
			const res = await loginWithKey(keyToUse);
			isLoggingIn = false;
			onLoginSuccess(res);
		} catch (err) {
			isLoggingIn = false;
			if (err.message && (err.message.includes('fetch') || err.message.includes('network') || err.message.includes('Failed'))) {
				loginError = "Não foi possível conectar ao servidor. Verifique se o servidor está ativo.";
			} else {
				loginError = err.message || "Chave de acesso inválida ou expirada.";
			}
		}
	}

	async function handleEmailLogin() {
		const emailClean = email.trim();
		const passClean = password.trim();
		if (!emailClean || !passClean) {
			loginError = "Por favor, preencha o e-mail e a senha.";
			return;
		}
		isLoggingIn = true;
		loginError = "";
		try {
			const res = await loginWithEmail(emailClean, passClean);
			isLoggingIn = false;
			onLoginSuccess(res);
		} catch (err) {
			isLoggingIn = false;
			if (err.message && (err.message.includes('fetch') || err.message.includes('network') || err.message.includes('Failed'))) {
				loginError = "Não foi possível conectar ao servidor. Verifique se o servidor está ativo.";
			} else {
				loginError = err.message || "E-mail ou senha incorretos.";
			}
		}
	}
</script>

<div class="login-page">
	<!-- Card Centralizado Único de Login (Padrão do Esboço) -->
	<div class="login-card">
		<!-- Logo Oficial do MataFome (Hero Dark - Branco & Laranja nítido) -->
		<div class="brand-logo-container">
			<img src="./brand/matafome_logo_hero_dark.png" alt="MataFome • Seu pedido, mais feliz" class="brand-logo-img" />
		</div>

		<!-- Títulos de Boas-vindas -->
		<h1 class="login-title">Bem-vindo ao MataFome</h1>
		<p class="login-subtitle">Entre para gerenciar seu restaurante.</p>

		<!-- Formulário de Autenticação -->
		<div class="login-form">
			<div class="field-group">
				<label for="email-input">E-mail ou Usuário</label>
				<input
					id="email-input"
					type="text"
					placeholder="seu@email.com ou usuario"
					bind:value={email}
					autocomplete="username"
				/>
			</div>

			<div class="field-group">
				<div class="label-row">
					<label for="pass-input">Senha</label>
					<button
						type="button"
						class="forgot-link-btn"
						on:click|preventDefault={() => { showForgotModal = true; forgotEmail = email.trim(); }}
					>
						Esqueceu sua senha?
					</button>
				</div>
				<div class="password-wrapper">
					{#if showPassword}
						<input
							id="pass-input"
							type="text"
							placeholder="••••••••"
							bind:value={password}
							autocomplete="current-password"
						/>
					{:else}
						<input
							id="pass-input"
							type="password"
							placeholder="••••••••"
							bind:value={password}
							autocomplete="current-password"
						/>
					{/if}
					<button
						type="button"
						class="toggle-eye"
						on:click={() => (showPassword = !showPassword)}
						title="Alternar visibilidade da senha"
					>
						{#if showPassword}
							<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
								<circle cx="12" cy="12" r="3"></circle>
							</svg>
						{:else}
							<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
								<line x1="1" x2="23" y1="1" y2="23"></line>
							</svg>
						{/if}
					</button>
				</div>
			</div>

			{#if loginError}
				<div class="login-error-badge">
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
						<circle cx="12" cy="12" r="10"></circle>
						<line x1="12" x2="12" y1="8" y2="12"></line>
						<line x1="12" x2="12.01" y1="16" y2="16"></line>
					</svg>
					<span>{loginError}</span>
				</div>
			{/if}

			<button class="btn-primary-entrar" on:click={handleEmailLogin} disabled={isLoggingIn}>
				{isLoggingIn ? "Entrando..." : "Entrar"}
			</button>
		</div>

		<!-- Divisor Discreto -->
		<div class="divider">
			<span>ou</span>
		</div>

		<!-- Chave de Acesso Secundária -->
		<div class="key-section">
			<p class="key-prompt">Possui uma chave de acesso?</p>
			<input
				id="key-input"
				type="text"
				placeholder="Ex: MATA-PRO-XXXX"
				bind:value={accessKey}
			/>
			<button class="btn-outline-ativar" on:click={handleKeyLogin} disabled={isLoggingIn}>
				{isLoggingIn ? "Ativando..." : "Ativar Acesso"}
			</button>
		</div>

		<!-- Rodapé Discreto -->
		<div class="footer-terms">
			<span>MataFome Desktop v1.0.0 • Termos de Uso · Privacidade</span>
			<div class="master-access-row">
				<button type="button" class="btn-master-link" on:click={() => { if (onOpenMaster) onOpenMaster(); }}>
					<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
						<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
					</svg>
					<span>Portal Master SaaS</span>
				</button>
			</div>
		</div>
	</div>

	<!-- Modal de Recuperação de Senha (Fase D) -->
	{#if showForgotModal}
		<div class="modal-backdrop" on:click|self={closeForgotModal}>
			<div class="forgot-modal" role="dialog" aria-modal="true" aria-labelledby="forgot-title">
				<div class="forgot-modal-header">
					<div class="forgot-icon">
						<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
							<path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
						</svg>
					</div>
					<h3 id="forgot-title">Recuperar Acesso</h3>
					<p>Informe o e-mail de cadastro da sua loja ou do seu operador para receber as instruções.</p>
				</div>

				{#if forgotMessage}
					<div class="forgot-success-box">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
							<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
							<polyline points="22 4 12 14.01 9 11.01"></polyline>
						</svg>
						<span>{forgotMessage}</span>
					</div>
					<div class="forgot-actions">
						<button type="button" class="btn-primary-modal" on:click={closeForgotModal}>
							Fechar
						</button>
					</div>
				{:else}
					{#if forgotError}
						<div class="forgot-error-box">
							<span>{forgotError}</span>
						</div>
					{/if}

					<form on:submit|preventDefault={handleForgotPassword} class="forgot-form">
						<div class="field-group">
							<label for="forgot-email-input">E-mail de Cadastro</label>
							<input
								id="forgot-email-input"
								type="email"
								placeholder="exemplo@restaurante.com.br"
								bind:value={forgotEmail}
								disabled={isSendingForgot}
								required
							/>
						</div>

						<div class="forgot-actions">
							<button type="button" class="btn-cancel-modal" on:click={closeForgotModal} disabled={isSendingForgot}>
								Cancelar
							</button>
							<button type="submit" class="btn-primary-modal" disabled={isSendingForgot}>
								{isSendingForgot ? 'Enviando...' : 'Enviar Instruções'}
							</button>
						</div>
					</form>
				{/if}
			</div>
		</div>
	{/if}
</div>

<style>
	.login-page {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		min-height: 100%;
		background: radial-gradient(circle at 50% 30%, #1A1F2B 0%, #0A0D14 70%);
		padding: 32px 16px;
		box-sizing: border-box;
		overflow-y: auto;
	}

	.login-card {
		width: 100%;
		max-width: 420px;
		background: #11141C;
		border: 1px solid rgba(255, 255, 255, 0.08);
		border-radius: 20px;
		padding: 36px 32px 28px 32px;
		box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
	}

	.brand-logo-container {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto 20px auto;
		max-width: 200px;
	}

	.brand-logo-img {
		width: 100%;
		height: auto;
		display: block;
		object-fit: contain;
	}

	.login-title {
		font-size: 23px;
		font-weight: 800;
		color: #FFFFFF;
		letter-spacing: -0.4px;
		margin: 0 0 6px 0;
		line-height: 1.25;
		text-align: center;
	}

	.login-subtitle {
		font-size: 13px;
		font-weight: 500;
		color: #94A3B8;
		margin: 0 0 24px 0;
		line-height: 1.4;
		text-align: center;
	}

	/* Formulário Principal */
	.login-form {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.field-group {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.field-group label {
		font-size: 11px;
		font-weight: 800;
		color: #CBD5E1;
		text-transform: uppercase;
		letter-spacing: 0.6px;
	}

	.label-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.field-group input {
		width: 100%;
		padding: 13px 15px;
		border-radius: 10px;
		border: 1px solid rgba(255, 255, 255, 0.12);
		font-size: 14px;
		font-family: inherit;
		color: #FFFFFF;
		transition: all 0.2s ease;
		background: #171B24;
		box-sizing: border-box;
	}

	.field-group input:focus {
		outline: none;
		border-color: #FF6A00;
		background: #1D222E;
		box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.22);
	}

	.field-group input::placeholder {
		color: #64748B;
	}

	.password-wrapper {
		position: relative;
		display: flex;
		align-items: center;
	}

	.toggle-eye {
		position: absolute;
		right: 12px;
		background: none;
		border: none;
		cursor: pointer;
		color: #64748B;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4px;
		transition: color 0.2s;
	}

	.toggle-eye:hover {
		color: #FFFFFF;
	}

	.forgot-link-btn {
		background: none;
		border: none;
		padding: 0;
		font-size: 12px;
		font-weight: 700;
		color: #FF6A00;
		cursor: pointer;
		text-decoration: none;
		transition: opacity 0.2s;
		font-family: inherit;
	}

	.forgot-link-btn:hover {
		text-decoration: underline;
		opacity: 0.9;
	}

	/* Modal de Recuperação de Senha */
	.modal-backdrop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.75);
		backdrop-filter: blur(4px);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
		padding: 20px;
		box-sizing: border-box;
	}

	.forgot-modal {
		background: #11141C;
		border: 1px solid rgba(255, 255, 255, 0.12);
		border-radius: 18px;
		padding: 28px;
		max-width: 420px;
		width: 100%;
		box-shadow: 0 24px 60px rgba(0, 0, 0, 0.7);
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	.forgot-modal-header {
		text-align: center;
	}

	.forgot-icon {
		width: 48px;
		height: 48px;
		border-radius: 12px;
		background: rgba(255, 106, 0, 0.12);
		color: #FF6A00;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 auto 12px auto;
	}

	.forgot-modal-header h3 {
		font-size: 18px;
		font-weight: 800;
		color: #FFFFFF;
		margin: 0 0 6px 0;
	}

	.forgot-modal-header p {
		font-size: 13px;
		color: #94A3B8;
		margin: 0;
		line-height: 1.4;
	}

	.forgot-form {
		display: flex;
		flex-direction: column;
		gap: 18px;
	}

	.forgot-actions {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
		margin-top: 8px;
	}

	.btn-cancel-modal {
		background: rgba(255, 255, 255, 0.08);
		border: 1px solid rgba(255, 255, 255, 0.1);
		color: #94A3B8;
		padding: 10px 18px;
		border-radius: 8px;
		font-weight: 600;
		font-size: 13px;
		cursor: pointer;
		transition: all 0.2s;
	}

	.btn-cancel-modal:hover:not(:disabled) {
		background: rgba(255, 255, 255, 0.14);
		color: #FFFFFF;
	}

	.btn-primary-modal {
		background: #FF6A00;
		border: none;
		color: #FFFFFF;
		padding: 10px 20px;
		border-radius: 8px;
		font-weight: 700;
		font-size: 13px;
		cursor: pointer;
		transition: all 0.2s;
	}

	.btn-primary-modal:hover:not(:disabled) {
		background: #E85A00;
		transform: translateY(-1px);
	}

	.forgot-success-box {
		background: rgba(16, 185, 129, 0.12);
		border: 1px solid rgba(16, 185, 129, 0.3);
		border-radius: 10px;
		padding: 14px;
		color: #10B981;
		font-size: 13px;
		display: flex;
		align-items: center;
		gap: 10px;
		line-height: 1.4;
	}

	.forgot-error-box {
		background: rgba(239, 68, 68, 0.12);
		border: 1px solid rgba(239, 68, 68, 0.3);
		border-radius: 10px;
		padding: 12px;
		color: #EF4444;
		font-size: 12px;
	}

	/* Erro */
	.login-error-badge {
		display: flex;
		align-items: center;
		gap: 8px;
		background: rgba(239, 68, 68, 0.15);
		color: #F87171;
		border: 1px solid rgba(239, 68, 68, 0.3);
		padding: 10px 14px;
		border-radius: 10px;
		font-size: 12px;
		font-weight: 600;
	}

	/* Botão Principal ENTRAR */
	.btn-primary-entrar {
		width: 100%;
		padding: 13px 16px;
		border-radius: var(--radius-md, 10px);
		border: 1.5px solid var(--brand-primary, #FF6A00);
		background: var(--brand-primary, #FF6A00);
		color: #FFFFFF;
		font-size: 14px;
		font-weight: 700;
		letter-spacing: 0;
		cursor: pointer;
		transition: background-color 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease;
		font-family: var(--font-sans, inherit);
		margin-top: 4px;
		box-shadow: 0 2px 10px rgba(255, 106, 0, 0.3);
	}

	.btn-primary-entrar:hover:not(:disabled) {
		background: var(--brand-primary-hover, #E85A00);
		border-color: var(--brand-primary-hover, #E85A00);
		box-shadow: 0 4px 18px rgba(255, 106, 0, 0.45);
		transform: translateY(-1px);
	}

	.btn-primary-entrar:active:not(:disabled) {
		transform: scale(0.98);
	}

	.btn-primary-entrar:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	/* Divisor Discreto */
	.divider {
		display: flex;
		align-items: center;
		text-align: center;
		margin: 22px 0 16px 0;
	}

	.divider::before,
	.divider::after {
		content: "";
		flex: 1;
		border-bottom: 1px solid rgba(255, 255, 255, 0.08);
	}

	.divider span {
		padding: 0 14px;
		font-size: 12px;
		font-weight: 600;
		color: #64748B;
	}

	/* Chave de Acesso */
	.key-section {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.key-prompt {
		font-size: 12px;
		font-weight: 600;
		color: #94A3B8;
		margin: 0;
	}

	.key-section input {
		width: 100%;
		padding: 11px 14px;
		border-radius: 10px;
		border: 1px solid rgba(255, 255, 255, 0.1);
		font-size: 13px;
		font-family: inherit;
		color: #FFFFFF;
		background: #171B24;
		box-sizing: border-box;
		transition: all 0.2s ease;
	}

	.key-section input:focus {
		outline: none;
		border-color: #FF6A00;
		background: #1D222E;
		box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.2);
	}

	.btn-outline-ativar {
		width: 100%;
		padding: 11px 14px;
		border-radius: var(--radius-md, 10px);
		border: 1.5px solid rgba(255, 255, 255, 0.12);
		background: transparent;
		color: #94A3B8;
		font-weight: 600;
		font-size: 13px;
		letter-spacing: 0;
		cursor: pointer;
		transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
		font-family: var(--font-sans, inherit);
	}

	.btn-outline-ativar:hover:not(:disabled) {
		border-color: var(--brand-primary, #FF6A00);
		color: var(--brand-primary, #FF6A00);
		background: rgba(255, 106, 0, 0.07);
	}

	.btn-outline-ativar:disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}

	/* Rodapé */
	.footer-terms {
		font-size: 11px;
		font-weight: 500;
		color: #64748B;
		text-align: center;
		margin-top: 24px;
		letter-spacing: 0.2px;
	}

	.master-access-row {
		margin-top: 10px;
		display: flex;
		justify-content: center;
	}

	.btn-master-link {
		background: none;
		border: none;
		color: #64748B;
		font-size: 11px;
		font-weight: 600;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		cursor: pointer;
		padding: 4px 8px;
		border-radius: 6px;
		transition: all 0.15s ease;
	}

	.btn-master-link:hover {
		color: #FF6A00;
		background: rgba(255, 106, 0, 0.08);
	}
</style>
